import React from 'react';

import { ModbusHostsScan } from '../network/modbus-hosts-scan';

/**
 * Wizard-facing wrapper around {@link ModbusHostsScan}, which keeps the MAC-only
 * selection the wizard submits. The configurator uses `ModbusHostsScan` directly so it
 * can also read the scanned IPv4.
 */
export const ExternalNetworkHostsScan = ({
  value,
  onChange,
}: {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}) => (
  <ModbusHostsScan value={value} onSelect={(host) => onChange(host?.mac)} />
);
